module.exports = __webpack_public_path__ + "account/assets/ref-reload-icon-white.5ee3d1e3.svg";